import { useNavigate } from 'react-router-dom';

import { FormGeneral } from '../FormGeneral/FormGeneral';
import { FormProspectus } from '../FormProspectus/FormProspectus';
import { FormInvoicing } from '../FormInvoicing/FormInvoicing';
import { RequestFormSummary } from '../Summary/RequestFormSummary';
import { renderForm } from 'bxcommon/helpers/form.helper';

// Equity
const equitySteps = [
  { no: 0, component: <FormGeneral isEquity /> },
  { no: 1, component: <FormProspectus /> },
  { no: 2, component: <FormInvoicing /> },
  { no: 3, component: <RequestFormSummary isEquity /> },
];

const debtSteps = [
  { no: 0, component: <FormGeneral /> },
  { no: 1, component: <FormProspectus /> },
  { no: 2, component: <FormInvoicing /> },
  { no: 3, component: <RequestFormSummary /> },
];

const derivativesSteps = [
  { no: 0, component: <FormGeneral /> },
  { no: 1, component: <FormProspectus /> },
  { no: 2, component: <FormInvoicing /> },
  { no: 3, component: <RequestFormSummary /> },
];

const EquityForm = renderForm(equitySteps, 'equity', 'ES');
const DebtForm = renderForm(debtSteps, 'debt', 'DS');
const DerivativesForm = renderForm(derivativesSteps, 'derivatives', 'DP');

const RequestView = ({ type }) => {
  const navigate = useNavigate();

  // based on the type, render the appropriate form, or navigate to the list view
  if (type === 'equity') {
    return <EquityForm />;
  } else if (type === 'debt') {
    return <DebtForm />;
  } else if (type === 'derivative') {
    return <DerivativesForm />;
  } else {
    // If the type is not recognized, navigate to the list view
    navigate('/list');
    return null;
  }
};

export default RequestView;
